module.exports = __webpack_public_path__ + "static/media/sc6.19cfdaf1.jpg";